<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <v-card class="box">
      <v-row justify="center" dense>
        <!-- <p><v-icon color="error">*</v-icon><b>Report Type</b></p> -->
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col cols="12" sm="4" md="4">
          <!-- <p><v-icon color="error">*</v-icon><b>Report Type</b></p> -->
          <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
            <v-radio label="Inward" value="inward" color="#0f2027"></v-radio>
            <v-radio label="Outward " value="outward" color="#0f2027"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="4" md="4">
          <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
          <v-menu ref="menu11" v-model="menu11" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_1" label="From Date (Inclusive)" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" persistent-hint hint="YYYY-MM-DD FORMAT"></v-text-field>
            </template>
            <v-date-picker v-model="date_1" @input="menu11 = false" ref="rv"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="4" md="4">
          <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
          <v-menu ref="menu22" v-model="menu22" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_2" label="To Date (Exclusive)" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" persistent-hint hint="YYYY-MM-DD FORMAT"></v-text-field>
            </template>
            <v-date-picker v-model="date_2" @input="menu22 = false" ref="rv"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col col="12" sm="2" md="2">
          <v-btn class="button" @click="fetchReport()">Fetch</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- inward report card  -->

    <v-card class="box" v-if="inward_flag && inward_list != ''">
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <!-- <v-btn color="success" outlined rounded>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="inward_list"
              :fields="in_table_fields"
              worksheet="InwardReport"
              name="InwardReport.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn> -->
          <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'InwardsReports')"
            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <v-col sm="4" md="4" cols="12">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <div id="my-table-id">
        <v-data-table :headers="in_headers" :items="inward_list" :search="search">
          <!-- <v-data-table :headers="headers1"> -->
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Inward Report</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <!-- inward report card end -->

    <!-- outward report card  -->

    <v-card class="box" v-if="outward_flag && outward_list != ''">
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <!-- <v-btn color="success" outlined rounded>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="outward_list"
              :fields="out_table_fields"
              worksheet="OutwardReport"
              name="OutwardReport.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn> -->
          <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'OutwardsReports')"
            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <div id="my-table-id">
        <v-data-table :headers="out_headers" :items="outward_list" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Outward Report</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <!-- outward report card end -->
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",

    ///////////////////////////////////////////////
    outward_list: [],
    inward_list: [],
    radios: null,
    menu11: false,
    inward_flag: false,
    outward_flag: false,
    search: "",
    date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    // date_1: new Date(date.getFullYear(), date.getMonth(), 1),
    menu22: false,
    date_2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),

    out_headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Outward No", value: "outward_no" },
      { text: "Outward Date", value: "iodate" },
      { text: "Sender", value: "sender.name" },
      { text: "Receiver", value: "outwardreceiver.name" },
      { text: "Description", value: "description" },
      { text: "Address", value: "address" },
    ],
    out_table_fields: {
      "Sr. No": "srno",
      "Outward No": "outward_no",
      "Outward Date": "iodate",
      Sender: "sender.name",
      Receiver: "outwardreceiver.name",
      Description: "description",
      Address: "address",
    },

    in_headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Inward No", value: "inward_no" },
      { text: "Outward No", value: "outward_no" },
      { text: "Inward Date", value: "iodate" },
      { text: "Sender", value: "sender.name" },
      { text: "I-Receiver", value: "receiver" },
      { text: "Handover To", value: "handoverto" },
      { text: "Description", value: "description" },
    ],
    in_table_fields: {
      "Sr. No": "srno",
      "Inward No": "inward_no",
      "Outward No": "outward_no",
      "Inward Date": "iodate",
      Sender: "sender.name",
      "I-Receiver": "receiver",
      "Handover To": "handoverto",
      Description: "description",
    },
  }),
  mounted() {},

  methods: {
     fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    dateFun() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1)
        .toISOString()
        .substr(0, 10);

      alert("first day " + firstDay + " last day" + lastDay);
    },
    fetchReport() {
      // alert("in fetch function");
      if (this.radios == "inward") {
        this.inward_flag = true;
        this.outward_flag = false;
      }
      if (this.radios == "outward") {
        this.outward_flag = true;
        this.inward_flag = false;
      }
      const formdata = {
        from_date: this.date_1,
        to_date: this.date_2,
      };
      axios
        .post("/inwardOutward/fetchinwardoutward", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.outward_list = res.data.outward_list;
            this.inward_list = res.data.inward_list;
            if (this.inward_list == "" || this.outward_list == "") {
              // alert("No Records found for selected date range.");
              this.showSnackbar(
                "#b71c1c",
                "No Records found for selected date range !!"
              );
            }
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }

          this.overlay = false;
        })

        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
};
</script>

<style scoped>
/* data table heading css */
.v-data-table ::v-deep th {
  font-size: 14px !important;
  font-weight: 800 !important;
}
/* data table heading css end */
</style>